import { useState } from "react";
import { useNavigate } from "react-router-dom";
import API from "../../API/api";
import "../../App.css";

export default function Signup() {
  const [formData, setformData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setformData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSignup = async (e) => {
    e.preventDefault();
    try {
      await API.post(
        "/auth/signup",
        formData,
        { withCredentials: true }
      );

      alert("Signup successful. Please login.");
      navigate("/login");
    } catch (err) {
      alert(
        "Error signing up: " +
          (err.response?.data?.message || err.message)
      );
    }
  };

  return (
    <div className="signup">
      <h2>Sign Up</h2>
      <form onSubmit={handleSignup}>
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          value={formData.password}
          onChange={handleChange}
          required
        />
        <button type="submit">Create my account</button>
      </form>
    </div>
  );
}

